import NavigationService from "@ane/core/lib/services/NavigationService";
import { ROUTES } from "./Routes.constants.js";
const navigateToPivot = (flightId, pivot) => {
  NavigationService.navigateTo(`${ROUTES.flightDetails.location.pathname}/${flightId}/${pivot}`);
};
const constructFlightDetailsURL = (flightId, workspaceId, managementGroup, pivot, view) => {
  const defaultId = !!flightId ? flightId.toLowerCase() : "";
  const pivotPath = pivot ? `/${pivot}` : "";
  const viewPath = view ? `/${view}` : "";
  const params = constructQueryString(getFlightQueryParams(managementGroup, workspaceId));
  const newPath = `${ROUTES.flightDetails.location.pathname}/${defaultId}${pivotPath}${viewPath}${params}`;
  return NavigationService.getCustomQueryParams(newPath);
};
const toggleCompositionEditView = (flightId, workspaceId, managementGroup, toggle = true) => {
  const view = toggle ? "compositionEdit" : void 0;
  const path = constructFlightDetailsURL(flightId, workspaceId, managementGroup, "composition", view);
  NavigationService.navigateTo(path);
};
const toggleFlightEditView = (flightId, workspaceId, managementGroup, pivot, toggle = true) => {
  const view = toggle ? "edit" : void 0;
  const path = constructFlightDetailsURL(flightId, workspaceId, managementGroup, pivot, view);
  NavigationService.navigateTo(path);
};
const getFlightQueryParams = (managementGroup, workspaceId) => {
  const result = [];
  if (!!managementGroup)
    result.push(`managementGroup=${managementGroup}`);
  if (!!workspaceId)
    result.push(`workspaceId=${workspaceId}`);
  return result;
};
const constructQueryString = (params) => {
  return `?${params.join("&")}`;
};
var FlightPivots = /* @__PURE__ */ ((FlightPivots2) => {
  FlightPivots2["details"] = "details";
  FlightPivots2["variables"] = "variables";
  FlightPivots2["traffic"] = "traffic";
  FlightPivots2["composition"] = "composition";
  FlightPivots2["archivedByExp"] = "-archivedbyexp";
  return FlightPivots2;
})(FlightPivots || {});
var FlightViewConstants = /* @__PURE__ */ ((FlightViewConstants2) => {
  FlightViewConstants2["edit"] = "edit";
  FlightViewConstants2["compositionEdit"] = "compositionEdit";
  return FlightViewConstants2;
})(FlightViewConstants || {});
const BING_SETFLIGHT_LINK = "https://bing.com/corpnet/signin?returnurl=https%3A%2F%2Fwww.bing.com%2F%3Fsetflight%3D";
const BING_EXPANDED_FEATURE_LINK = "https://www.bing.com/search?q=test&features=";
export {
  BING_EXPANDED_FEATURE_LINK,
  BING_SETFLIGHT_LINK,
  FlightPivots,
  FlightViewConstants,
  constructFlightDetailsURL,
  constructQueryString,
  getFlightQueryParams,
  navigateToPivot,
  toggleCompositionEditView,
  toggleFlightEditView
};
//# sourceMappingURL=FlightRoute.utils.js.map
